import { catalogCenterZh } from "./catalog-center";
import { centersCenterZh } from "./centers-center";
import { loginCenterZh } from "./login-center";
import { platformAdminApplications } from "./platform-admin-applications";
import { platformAdminAssets } from "./platform-admin-assets";
import { platformAdminCommon } from "./platform-admin-common";
import { platformAdminDashboard } from "./platform-admin-dashboard";
import { platformAdminExecution } from "./platform-admin-execution";
import { platformAdminIdentity } from "./platform-admin-identity";
import { platformAdminNavigation } from "./platform-admin-navigation";
import { platformAdminPortalManagement } from "./platform-admin-portal-management";
import { platformAdminValues } from "./platform-admin-values";

export const platformAdmin = {
  title: "平台后台",
  shellSubtitle: "平台控制面",
  links: platformAdminNavigation.links,
  menu: platformAdminNavigation.menu,
  common: platformAdminCommon,
  values: platformAdminValues,
  dashboard: platformAdminDashboard,
  applications: platformAdminApplications,
  portalManagement: platformAdminPortalManagement,
  assets: platformAdminAssets,
  execution: platformAdminExecution,
  identity: platformAdminIdentity,
  centers: centersCenterZh,
  catalog: catalogCenterZh,
  login: loginCenterZh,
} as const;
